/**
 * Knowledge Vault 내보내기 — 순수 변환(Markdown/JSON) + 다운로드 헬퍼.
 * Notion/Obsidian은 Markdown import을 지원하므로 .md export로 호환. $0, 외부호출 0.
 */
import type { VaultNote } from './api';

const KIND_LABEL: Record<string, string> = {
  memo: 'memo', quote: 'quote', insight: 'insight', feedback: 'feedback',
};

export function notesToMarkdown(notes: VaultNote[]): string {
  const head = `# Knowledge Vault (${notes.length})\n`;
  const body = notes.map((n) => {
    const day = n.created_at ? n.created_at.slice(0, 10) : '';
    const tags = n.tags.length ? `\ntags: ${n.tags.map((t) => `#${t}`).join(' ')}` : '';
    return `## [${KIND_LABEL[n.kind] ?? n.kind}] ${day}\n${n.content}${tags}`;
  }).join('\n\n');
  return `${head}\n${body}\n`;
}

export function notesToJson(notes: VaultNote[]): string {
  return JSON.stringify(
    notes.map((n) => ({
      kind: n.kind, content: n.content, tags: n.tags,
      book_id: n.book_id ?? null, created_at: n.created_at ?? null,
    })),
    null, 2,
  );
}

/** Blob 다운로드 (브라우저 전용). */
export function downloadText(filename: string, content: string, mime: string): void {
  const blob = new Blob([content], { type: `${mime};charset=utf-8` });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  URL.revokeObjectURL(url);
}
